import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import metrics from './metrics';
import Vector from './cvss40';
import Wrapper from './styled';
import ExpandableWrapper from './components/ExpandableWrapper';
import { updateCvssV4 } from 'store/Manage/actions';
import { updateCvssV4General } from 'store/ManageGeneral/actions';
import { updateCvssV4FromAsset } from 'store/Contextualization/AssetDetail/actions';
import DetailsSection from './components/DetailSection';
import CalculatorSection from './components/CalculatorSection';

const CVSS4Calculator = ({ cvss4Data, entity }) => {
  const vectorString = cvss4Data?.vector_string;
  const [currentVectorString, setCurrentVectorString] = useState(vectorString || '');
  const vectorInstance = new Vector(currentVectorString);
  const details = vectorInstance.severityBreakdown();
  const macroVector = vectorInstance.equivalentClasses();
  const vectorMetrics = [vectorInstance.metrics];
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentVectorString(vectorString || '');
  }, [vectorString]);

  const handleClick = (metric, value) => {
    if (!value) return;

    const nextVector = new Vector(currentVectorString);
    nextVector.updateMetric(metric, value);
    const nextVectorString = nextVector.raw();

    setCurrentVectorString(nextVectorString);

    if (entity === 'vulns') {
      dispatch(updateCvssV4(nextVectorString));
    } else if (entity === 'vulnsGeneral') {
      dispatch(updateCvssV4General(nextVectorString));
    } else {
      dispatch(updateCvssV4FromAsset(nextVectorString));
    }
  };

  return (
    <Wrapper>
      <ExpandableWrapper
        sectionTitle="Details"
        content={ <DetailsSection vectorString={ currentVectorString } details={ details } macroVector={ macroVector } /> }
      />
      { vectorInstance.metrics && metrics.map((item) =>
        <ExpandableWrapper
          key={ item.metricType }
          sectionTitle={ item.metricType }
          defaultExpanded={ item.metricType === 'Base Metrics' }
          content={ <CalculatorSection info={ item } handleClick={ handleClick } vectorMetrics={ vectorMetrics } /> }
        />
      )}
    </Wrapper>
  );
};

export default CVSS4Calculator;
